<template>
  <div
    :class="
      navigation || culturePop
        ? 'popup'
        : '' || startProjectPop || recruitPop
        ? 'popup black'
        : '' || awardsPop
        ? 'black-gra'
        : ''
    "
    class="container viewPage orangeLifeView"
  >
    <header-area />
    <div class="worksView">
      <div class="contsBox">
        <div class="viewInCon">
          <div class="workTopTitle">
            <div class="workSlogan web">Evoked Orange<br />Orange Life Online Marketing</div>
            <div class="workSlogan mobile">
              Evoked Orange<br />Orange Life<br />Online Marketing
            </div>

            <div class="workTopDay">
              <p>오렌지라이프 온라인 마케팅 연간대행</p>
              <ul>
                <li>Digital Marketing</li>
                <li>2019.04.18</li>
              </ul>
            </div>
            <div class="workTopSns">
              <a href="#" target="_self" class="siteAddr noUnder">—</a>

              <ul>
                <li>
                  <social-sharing
                    url="https://www.pulip.com/sns/orangelife"
                    title="고객 커뮤니케이션 활성화를 위한 독창적 콘텐츠 마케팅, 오렌지라이프 '오늘'"
                    hashtags="플립커뮤니케이션즈,오렌지라이프,온라인마케팅"
                    twitter-user="플립커뮤니케이션즈"
                    inline-template
                  >
                    <network network="facebook">
                      <a href="javascript:;" class="wFacebook">
                        <img src="@/assets/images/@sns_fb_w.png" alt="" />
                      </a>
                    </network>
                  </social-sharing>
                </li>
                <li>
                  <social-sharing
                    url="https://www.pulip.com/sns/orangelife"
                    title="고객 커뮤니케이션 활성화를 위한 독창적 콘텐츠 마케팅, 오렌지라이프 '오늘'"
                    hashtags="플립커뮤니케이션즈,오렌지라이프,온라인마케팅"
                    twitter-user="플립커뮤니케이션즈"
                    inline-template
                  >
                    <network network="twitter">
                      <a href="javascript:;" class="wTweeter">
                        <img src="@/assets/images/@sns_tw_w.png" alt="" />
                      </a>
                    </network>
                  </social-sharing>
                </li>
                <li>
                  <a href="javascript:;" @click.prevent="doCopy" class="wChain">
                    <img src="@/assets/images/@web_link_w.png" alt="" />
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      <div class="workVisual">
        <div class="workImg">
          <span class="workMoveTxt"
            ><marquee-text :duration="18" :repeat="2"
              >&nbsp;Evoked Orange Orange Life Online Marketing</marquee-text
            ></span
          >
          <img src="@/assets/images/works_view/orangeLife/orangeLife_visual.jpg" alt="" />
        </div>
      </div>

      <div class="contsBox">
        <div class="topInfo">
          오렌지라이프는 2030세대가 생애 주기에 따라 향후 생명보험에 가입해야 하는 순간이 왔을 때
          바로 떠오르는 EVOKED SET(*소비자가 특정 물품을 구매하려고 할 때 생각나는 브랜드)에
          진입하기 위해 온라인 마케팅을 진행하고 있습니다. 2030세대를 위한 다양하고 흥미로운
          콘텐츠를 제공함으로써 고객의 자발적인 참여를 높이고, 이를 통해 잠재 고객을 확산시켜 마케팅
          효과를 한층 더 증대시키고자 했습니다.
        </div>
      </div>
    </div>

    <div class="wideConts">
      <!-- promotion_1 -->
      <div class="promotion_1">
        <div class="worksView">
          <div class="contsBox">
            <div class="promTitle web">
              <span class="promNum">Promotion 01</span>
              <strong class="promTxt">
                뼈 때리는 공감.
                <br />
                <span class="orangeL_line">콘텐츠로 재밌는 “오늘”</span>
              </strong>
            </div>

            <div class="promTitle mobile">
              <span class="promNum">Promotion 01</span>
              <strong class="promTxt">
                뼈 때리는 공감.
                <br />
                <span class="orangeL_line">콘텐츠로 재밌는 “오늘”</span>
              </strong>
            </div>
          </div>
        </div>

        <div class="p1_rollArea">
          <div class="inProM bigT">
            <img src="@/assets/images/works_view/orangeLife/promotion1_in.png" alt="" />
          </div>
          <div class="inProM midT">
            <img src="@/assets/images/works_view/orangeLife/promotion1_in_mid.png" alt="" />
          </div>
          <div class="promotion1_roll">
            <div class="swiper-container">
              <ul class="swiper-wrapper">
                <li class="swiper-slide">
                  <span>
                    <img src="@/assets/images/works_view/orangeLife/promotion1_roll1.jpg" alt="" />
                  </span>
                </li>
                <li class="swiper-slide">
                  <span>
                    <img src="@/assets/images/works_view/orangeLife/promotion1_roll2.jpg" alt="" />
                  </span>
                </li>
                <li class="swiper-slide">
                  <span>
                    <img src="@/assets/images/works_view/orangeLife/promotion1_roll3.jpg" alt="" />
                  </span>
                </li>
                <li class="swiper-slide">
                  <span>
                    <img src="@/assets/images/works_view/orangeLife/promotion1_roll4.jpg" alt="" />
                  </span>
                </li>
                <li class="swiper-slide">
                  <span>
                    <img src="@/assets/images/works_view/orangeLife/promotion1_roll5.jpg" alt="" />
                  </span>
                </li>
              </ul>
            </div>
          </div>

          <div class="worksView">
            <div class="contsBox">
              <div class="prom1_text">
                <strong>초록창에 없는 콘텐츠</strong>
                <span>
                  보험업계가 고객들에게 전달하는 범용 콘텐츠는 셀 수 없이 많습니다. 그렇기 때문에
                  오렌지라이프는 자사의 콘텐츠 제작에 있어 ‘희소성’을 가장 중요한 가치로 삼아
                  타사와의 차별화를 꾀했습니다.<br />
                  지점을 직접 방문해 어떤 방식으로 메신저를 사용하는지, 모바일로 주로 접촉하는
                  고객의 특성은 무엇인지, 콘텐츠를 발신할 때 어떤 루틴을 갖고 있는지 등 현장의
                  생생한 이야기를 수집한 후 이를 콘텐츠에 반영했습니다.
                </span>
              </div>
            </div>
          </div>
        </div>

        <div class="worksView">
          <div class="contsBox">
            <div class="monthCy">
              <ul>
                <li class="monthCy1">
                  <div>
                    고객방문
                    <br />
                    <span>100만건</span> 돌파
                  </div>
                </li>
                <li class="monthCy2">
                  <div>
                    1000건 이상의
                    <br />
                    고객 상담 신청 및
                    <br />
                    방문설계
                  </div>
                </li>
              </ul>
              <div class="resultTxt">
                <div class="resultTxt_in">
                  <span>Result</span>
                  <strong>2month</strong>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="movieAreaP1">
          <video
            id="orangelifeMovie1"
            controls
            playsinline
            muted="muted"
            autoplay="autoplay"
            preload="auto"
            loop="loop"
            poster="@/assets/images/works_view/orangeLife/promotion2_movie.jpg"
          >
            <source src="/download/media/orangelife_movie1.mp4" type="video/mp4" />
          </video>
        </div>
      </div>
      <!-- //promotion_1 -->

      <!-- promotion_2 -->
      <div class="promotion_2">
        <div class="worksView">
          <div class="contsBox">
            <div class="promTitle web">
              <span class="promNum">Promotion 02</span>
              <strong class="promTxt">
                캠페인으로 시작해서 브랜드를 만들어내다&nbsp;
                <span class="orangeL_line">“FIT ON YOU”</span>
              </strong>
            </div>

            <div class="promTitle mobile">
              <span class="promNum">Promotion 02</span>
              <strong class="promTxt">
                캠페인으로<br />
                시작해서 브랜드를 만들어내다<br />
                <span class="orangeL_line">“FIT ON YOU”</span>
              </strong>
            </div>

            <div class="prom_text">
              FIT-ON YOU는 유전자 분석을 통해 나에게 딱 맞는 보장을 선택할 수 있는 완전히 새로운
              프로그램입니다. 고객들이 전문적이고 지속적인 관리 프로그램으로 인식하도록 제작한
              FIT-ON YOU 프로모션이 많은 관심을 받게 되면서 추후 브랜딩까지 제작하게 되었습니다.
            </div>
          </div>
        </div>

        <div class="prom2_sub">
          <div class="prom2_direcArea">
            <div class="prom2_subTit">Direction</div>
            <div class="prom2_direc">
              <p class="direcFirst">유전자 분석<br />서비스</p>
              <div class="direcList">
                <span class="direcLine">
                  <span />
                </span>
                <ul>
                  <li class="prom2_d1">
                    <div class="direcIn">
                      <div>
                        <strong>Professionalism</strong>
                        <span>관련 전문성</span>
                      </div>
                    </div>
                  </li>
                  <li class="prom2_d2">
                    <div class="direcIn">
                      <div>
                        <strong>Trust</strong>
                        <span>신뢰 / 믿음</span>
                      </div>
                    </div>
                  </li>
                  <li class="prom2_d3">
                    <div class="direcIn">
                      <div>
                        <strong>Continuous<br />Service</strong>
                        <span>지속적 서비스</span>
                      </div>
                    </div>
                  </li>
                </ul>
              </div>
              <p>맞춤형 보험상품<br />추천 / 판매</p>
            </div>
          </div>
          <div class="prom2_brandArea">
            <div class="prom2_subTit">Brand Identity</div>
            <div class="prom2_brand">
              <div class="bi_action">
                <img src="@/assets/images/works_view/orangeLife/bi_action.jpg" alt="" />
              </div>
              <div class="prom2_brandTxt">
                FIT-ON YOU는 ‘한 사람에게만 꼭 맞춰 설계되는 프로그램’이라는 뜻으로, 로고는 Square
                box 안 그리드에 맞춰 텍스트를 배치함으로써 ‘나만을 위한 커스텀 메이드 선물상자’라는
                느낌을 주고자 디자인했습니다.
              </div>
              <ul>
                <li class="bi_sub1">
                  <img src="@/assets/images/works_view/orangeLife/bi_sub1.jpg" alt="" />
                </li>
                <li class="bi_sub2">
                  <img src="@/assets/images/works_view/orangeLife/bi_sub2.jpg" alt="" />
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <!-- //promotion_2 -->

      <!-- promotion_3 -->
      <div class="promotion_3">
        <div class="worksView">
          <div class="contsBox">
            <div class="promTitle web">
              <span class="promNum">Promotion 03</span>
              <strong class="promTxt">
                소모임(강좌) 커뮤니티&nbsp;
                <span class="orangeL_line">“오-프렌즈” 런칭 캠페인</span>
              </strong>
            </div>

            <div class="promTitle mobile">
              <span class="promNum">Promotion 03</span>
              <strong class="promTxt">
                소모임(강좌) 커뮤니티<br />
                <span class="orangeL_line">“오-프렌즈” 런칭 캠페인</span>
              </strong>
            </div>

            <div class="prom_text">
              주 52시간 근무제 도입으로 인해 취미생활, 자기개발 등 워라밸 관련 키워드가 부상하게
              됨과 동시에 소비 트렌드가 급변함에 따라, 오렌지라이프는 오-프렌즈 플랫폼을
              런칭했습니다. 오-프렌즈 플랫폼은 평소 접하기 어려웠던 분야의 오프라인 강좌(소모임)에
              대한 정보를 제공하고 있으며, 앞으로도 계속해서 새로운 소모임을 런칭할 예정입니다. 이번
              캠페인을 통해 소모임에 대해 알고 있거나 경험해 본, 또는 관심이 있었던 고객들이 FC와
              자연스럽게 만날 수 있는 기회를 마련하고, 이를 통해 기존 고객과의 긍정적인 관계를 형성,
              신규 고객을 확대해 나갈 수 있을 것이라 기대해 봅니다.
            </div>
          </div>
        </div>

        <div class="worksView">
          <div class="movieAreaP3">
            <video
              id="orangelifeMovie3"
              controls
              playsinline
              preload="auto"
              loop="loop"
              poster="@/assets/images/works_view/orangeLife/promotion3_movie.jpg"
            >
              <source src="/download/media/orangelife_movie3.mp4" type="video/mp4" />
            </video>
          </div>
        </div>
      </div>
      <!-- //promotion_3 -->

      <!-- promotion_4 -->
      <div class="promotion_4">
        <div class="worksView">
          <div class="contsBox">
            <div class="promTitle web">
              <span class="promNum">Promotion 04</span>
              <strong class="promTxt">
                잠재적 고객을 확보하다.&nbsp;
                <span class="orangeL_line">오렌지라이프 X 배틀그라운드</span>
              </strong>
            </div>

            <div class="promTitle mobile">
              <span class="promNum">Promotion 04</span>
              <strong class="promTxt">
                잠재적 고객을 확보하다.<br />
                <span class="orangeL_line">오렌지라이프 X 배틀그라운드</span>
              </strong>
            </div>

            <div class="prom_text">
              잠재 고객 확보라는 명확한 목표 아래, 배틀그라운드 게임의 특성을 백분 활용한 온라인
              마케팅을 진행했습니다.<br />게임의 몰입을 방해하지 않으면서도 배틀그라운드의 유머
              요소를 활용하는 방향으로, 무형의 보험상품을 유형의 상품으로 인식하도록 해 고객이 그
              효과를 직접 경험할 수 있도록 유도했습니다.
            </div>
          </div>
        </div>

        <div class="prom4_conts">
          <div class="prom4_imgList">
            <div class="prom4_topImg">
              <img src="@/assets/images/works_view/orangeLife/promotion4_0.jpg" alt="" />
            </div>
            <div class="prom4_ulA1">
              <ul>
                <li class="prom4_img1">
                  <img src="@/assets/images/works_view/orangeLife/promotion4_1.jpg" alt="" />
                </li>
                <li class="prom4_img2">
                  <img src="@/assets/images/works_view/orangeLife/promotion4_2.jpg" alt="" />
                </li>
                <li class="prom4_img3">
                  <img src="@/assets/images/works_view/orangeLife/promotion4_3.jpg" alt="" />
                </li>
              </ul>
            </div>
            <div class="prom4_ulA2">
              <ul>
                <li class="prom4_img4">
                  <img src="@/assets/images/works_view/orangeLife/promotion4_4.jpg" alt="" />
                </li>
                <li class="prom4_img5">
                  <img src="@/assets/images/works_view/orangeLife/promotion4_5.jpg" alt="" />
                </li>
              </ul>
            </div>
          </div>

          <div class="prom4_rollArea">
            <div class="prom4_text">
              <strong>오렌지 라이프 X 배틀그라운드 굿즈</strong>
              <span>
                고객이 오랜지라이프 FC를 만나 재무상담뿐만 아니라 굿즈도 선물 받는 오프라인
                마케팅으로, 브랜드와 콜라보레이션을 진행해 단순 광고 플랫폼을 넘어 잠재 고객을
                확산시킨 성공적인 콘텐츠입니다.
              </span>
            </div>

            <div class="goodsRoll">
              <div class="goodsRoll_inr">
                <div class="swiper-container">
                  <ul class="swiper-wrapper">
                    <li class="swiper-slide">
                      <span>
                        <img src="@/assets/images/works_view/orangeLife/goods1.jpg" alt="" />
                      </span>
                    </li>
                    <li class="swiper-slide">
                      <span>
                        <img src="@/assets/images/works_view/orangeLife/goods2.jpg" alt="" />
                      </span>
                    </li>
                    <li class="swiper-slide">
                      <span>
                        <img src="@/assets/images/works_view/orangeLife/goods3.jpg" alt="" />
                      </span>
                    </li>
                    <li class="swiper-slide">
                      <span>
                        <img src="@/assets/images/works_view/orangeLife/goods4.jpg" alt="" />
                      </span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            <div class="allianceP">
              <strong>제휴 프로모션</strong>
              <ul>
                <li class="alliLogo1">
                  <img src="@/assets/images/works_view/orangeLife/alliance_logo1.png" alt="" />
                </li>
                <li class="alliLogo2">
                  <img src="@/assets/images/works_view/orangeLife/alliance_logo2.png" alt="" />
                </li>
                <li class="alliLogo3">
                  <img src="@/assets/images/works_view/orangeLife/alliance_logo3.png" alt="" />
                </li>
                <li class="alliLogo4">
                  <img src="@/assets/images/works_view/orangeLife/alliance_logo4.png" alt="" />
                </li>
                <li class="alliLogo5">
                  <img src="@/assets/images/works_view/orangeLife/alliance_logo5.png" alt="" />
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <!-- //promotion_4 -->
    </div>

    <div class="worksView">
      <div class="contsBox">
        <div class="backToList">
          <router-link :to="{ name: 'works' }" class="backBtn">
            <img src="@/assets/images/@ico_back_x2.jpg" alt="" />
            <span>Back to list</span>
          </router-link>
        </div>
      </div>

      <router-link v-if="true" :to="{ name: 'works-maumAI' }" class="longEnd vType">
        <div class="viewType">
          <span>next</span>
          <strong class="web">마음AI 플랫폼 이노베이션</strong>
          <strong class="mobile">마음AI<br />플랫폼 이노베이션</strong>
        </div>

        <div class="engBg maumEndBg">
          <span />
        </div>
      </router-link>
    </div>

    <footer-area />
  </div>
</template>

<script>
import { mapState } from "vuex";
import HeaderArea from "@/components/Header";
import FooterArea from "@/components/Footer";
import common from "@/shared/mixin/common.js";
import MarqueeText from "vue-marquee-text-component";

export default {
  mixins: [common],
  name: "Main",
  /* head: {
    title: {
      inner: '오렌지라이프'
    }
  }, */
  head: {
    title: function() {
      return {
        inner: this.meta.title
      };
    },
    meta: function() {
      return [
        {
          name: "description",
          content: this.meta.desc
        },
        {
          name: "keywords",
          content: this.meta.keywords
        },
        // Open Graph
        { property: "og:title", content: this.meta.title },
        { property: "og:description", content: this.meta.desc },
        { property: "og:type", content: "website" },
        { property: "og:url", content: this.meta.url },
        { property: "og:image", content: this.meta.img },

        // Additional OG tags
        { property: "og:site_name", content: this.meta.siteName }
      ];
    }
  },
  components: {
    HeaderArea,
    FooterArea,
    MarqueeText
  },
  data() {
    return {
      meta: {
        siteName: "오렌지라이프 온라인 마케팅 | 플립커뮤니케이션즈",
        title: "오렌지라이프 온라인 마케팅",
        desc:
          "오렌지라이프는 2030세대를 위한 다양하고 흥미로운 콘텐츠를 제공하여 잠재고객 확산과 마케팅 효과를 높이기 위해 온라인마케팅을 진행했습니다. 희소성 있는 콘텐츠 제작, 유전자분석 서비스 FIT-ON YOU 캠페인, 오-프렌즈 소모임 플랫폼 런칭, 배틀그라운드와의 제휴를 통해 잠재고객 확보에 성공한 사례입니다.",
        keywords:
          "온라인 마케팅, 생명보험, 2030세대, EVOKED SET, 콘텐츠 제작, 희소성, 메신저 사용, 모바일 접촉, 고객 상담, FIT-ON YOU, 유전자 분석, 워라밸, 오-프렌즈, 배틀그라운드, 제휴 프로모션",
        url: "https://www.pulip.com/works/orangelife",
        img: "https://www.pulip.com/pulip-logo.jpg"
      },
      OrangeLifeP1Slider: null,
      OrangeLifeP4Slider: null
    };
  },
  computed: {
    ...mapState("common", {
      startProjectPop: state => state.startProjectPop,
      recruitPop: state => state.recruitPop,
      awardsPop: state => state.awardsPop,
      culturePop: state => state.culturePop,
      navigation: state => state.navigation
    })
  },
  methods: {
    doCopy() {
      this.$copyText("https://www.pulip.com/works/orangelife").then(
        function(e) {
          alert("복사되었습니다.");
          console.log(e);
        },
        function(e) {
          console.log(e);
        }
      );
    }
  },
  mounted() {
    setTimeout(_ => {
      this.OrangeLifeP1Slider = new window.Swiper(".promotion_1 .swiper-container", {
        loop: true,
        speed: 1000,
        centeredSlides: true,
        autoplay: {
          delay: 2000,
          disableOnInteraction: false
        },

        breakpoints: {
          1921: {
            spaceBetween: 60,
            slidesPerView: 5
          },
          1367: {
            spaceBetween: 60,
            slidesPerView: 4
          },
          891: {
            spaceBetween: 40,
            slidesPerView: 4
          },
          376: {
            slidesPerView: 2,
            spaceBetween: 50
          },
          1: {
            slidesPerView: 1.5,
            spaceBetween: 20
          }
        }
      });
      this.OrangeLifeP4Slider = new window.Swiper(".promotion_4 .swiper-container", {
        loop: true,
        spaceBetween: 40,
        slidesPerView: "auto"
      });
    }, 100);
  },
  destroyed() {
    this.OrangeLifeP1Slider.destroy();
    this.OrangeLifeP4Slider.destroy();
  }
};
</script>
